// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"71":"e143dd91","111":"d0c3c71f","119":"a603813c","158":"9e93cd73","255":"596121ff","272":"75e9aa5a","426":"24ae1533","502":"0de2cfaa","734":"18b1ecb0","819":"589e630e","825":"2aaee880","833":"884847ca"}[chunkId] + ".js";
};